import { useLayoutEffect, useState } from 'react'

import { PHONE_MEDIA_QUERY, TABLET_MEDIA_QUERY } from '../breakpoints'

export type ListenerOptions = {
  custom?: number
  mobile?: boolean
  tablet?: boolean
}

export type MediaBreakPoints = {
  belowCustom: boolean
  belowMobile: boolean
  belowTablet: boolean
}

function useMediaQuery(options: ListenerOptions): MediaBreakPoints {
  const [belowMobile, setMobile] = useState(false)
  const [belowTablet, setTablet] = useState(false)
  const [belowCustom, setCustom] = useState(false)

  const { custom, mobile, tablet } = options

  const handleMediaQueryChange = (updater, { matches }) => updater(matches)

  useLayoutEffect(() => {
    if (typeof window !== 'undefined' && mobile) {
      const mql = window.matchMedia(PHONE_MEDIA_QUERY)
      const listener = handleMediaQueryChange.bind(null, setMobile)
      mql.addListener(listener)
      setMobile(mql.matches)

      return () => mql.removeListener(listener)
    }
  }, [mobile])

  useLayoutEffect(() => {
    if (typeof window !== 'undefined' && tablet) {
      const mql = window.matchMedia(TABLET_MEDIA_QUERY)
      const listener = handleMediaQueryChange.bind(null, setTablet)
      mql.addListener(listener)
      setTablet(mql.matches)

      return () => mql.removeListener(listener)
    }
  }, [tablet])

  useLayoutEffect(() => {
    if (typeof window !== 'undefined' && custom) {
      const CUSTOM_MEDIA_QUERY = `(max-width: ${custom}px)`
      const mql = window.matchMedia(CUSTOM_MEDIA_QUERY)
      const listener = handleMediaQueryChange.bind(null, setCustom)
      mql.addListener(listener)
      setCustom(mql.matches)

      return () => mql.removeListener(listener)
    }
  }, [custom])

  return { belowCustom, belowMobile, belowTablet }
}

export default useMediaQuery
